module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100vw"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "col-md-6 col-md-offset-4 col-xs-12"
  }, [_c('div', {
    staticClass: "loading-md"
  })]) : _c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('div', {
    staticClass: "row cart-widget",
    staticStyle: {
      "width": "100vw",
      "margin-top": "-0.2em"
    }
  }, [(((_vm.has_part_payments_request > 0) && (!_vm.buy_now_order))) ? _c('div', [_c('p', [_vm._v("you have some part payment orders")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs sp-button-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.part_payments_request_option = true;
        _vm.prepCart();
        _vm.has_part_payments_request = 0;
      }
    }
  }, [_vm._v("Process Part Payment Orders")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs sp-button-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.has_part_payments_request = 0
      }
    }
  }, [_vm._v("Process Orders")])]) : _c('div', {
    staticStyle: {
      "background": "#ffffff",
      "margin": "0 1em"
    }
  }, [_c('div', {
    staticClass: "cart-summ",
    staticStyle: {
      "text-align": "left",
      "width": "100%",
      "margin-bottom": "1em"
    }
  }, [(!_vm.buy_now_order) ? _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Select Items to checkout and click *Process Orders* to continue.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "15em"
    }
  }, _vm._l((_vm.sorted_cart), function(group, index) {
    return (group.can_show) ? _c('div', {
      staticClass: "group-row",
      staticStyle: {
        "margin-bottom": "2em",
        "height": "auto"
      }
    }, [(!_vm.buy_now_order) ? _c('div', [(group.is_from_agent && (group.is_from_agent == 1)) ? _c('p', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('a', {
      staticClass: "sp-app-default-color",
      attrs: {
        "href": group.business_agent_username
      }
    }, [_vm._v(_vm._s(group.business_agent_name))])]) : _c('p', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('a', {
      staticClass: "sp-app-default-color",
      attrs: {
        "href": group[0]
      }
    }, [_vm._v(_vm._s(group.business_name))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "none",
        "float": "right",
        "margin-right": "5px"
      }
    }, [_c('div', {
      staticStyle: {
        "height": "2em"
      }
    }, [(group.selected_business_delivery_option || group.delivery_general_set_option) ? _c('div', [(group.selected_business_delivery_option) ? _c('p', {
      staticStyle: {
        "font-size": "13px"
      }
    }, [_c('b', [_vm._v("Shipping: ")]), _vm._v(_vm._s(group.selected_business_delivery_option.business_delivery_option) + " - ₦" + _vm._s(group.selected_business_delivery_option.business_delivery_option_price))]) : _vm._e(), _vm._v(" "), (group.delivery_general_set_option && (group.delivery_general_set_option.city)) ? _c('p', {
      staticStyle: {
        "font-size": "13px"
      }
    }, [_c('b', [_vm._v("Shipping: ")]), _vm._v(_vm._s(group.delivery_general_set_option.city.city_name) + "-" + _vm._s(group.delivery_option))]) : _vm._e()]) : _c('div', [(group.business_min_delivery_fee != 0 && (group.business_max_delivery_fee.length != 0)) ? _c('div', [_c('p', {
      staticStyle: {
        "font-size": "13px"
      }
    }, [_c('b', [_vm._v("Shipping: ")]), _vm._v("₦" + _vm._s(group.business_min_delivery_fee) + " - ₦" + _vm._s(group.business_max_delivery_fee))])]) : _vm._e()])]), _vm._v(" "), (group.show_delivery_option > 0) ? _c('div', [(group[2] && (group[2].length == 0)) ? _c('div', [_c('p', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Free Delivery")])]) : _c('div', {
      key: _vm.shipping_fee_key_options,
      staticStyle: {
        "margin-top": "-1em"
      }
    }, [(group.delivery_states.length == 1) ? _c('div') : _c('div', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.delivery_selected_state),
        expression: "group.delivery_selected_state"
      }],
      staticClass: "sp-form-select sp-select",
      staticStyle: {
        "height": "28px",
        "padding": "0",
        "margin-bottom": "3px",
        "font-size": "12px"
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          group.delivery_selected_state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.getDeliveryLocations(index, group.delivery_selected_state)
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select")]), _vm._v(" "), _vm._l((group.delivery_states), function(state) {
      return _c('option', {
        domProps: {
          "value": state
        }
      }, [_vm._v(_vm._s(state.state_name))])
    })], 2)]), _vm._v(" "), (((group.delivery_states.length == 1) || (group.delivery_selected_state))) ? _c('div', {
      attrs: {
        "id": index + 'BDLS'
      }
    }, [_c('div', {
      key: _vm.componentDeliveryLocationsKey
    }, [(group.selected_delivery_state_locations.length != 0) ? _c('div', [_c('div', {
      staticClass: "dropdown"
    }, [(group.delivery_states.length == 1) ? _c('span', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(group.delivery_states[0].state_name) + ":")]) : _vm._e(), _vm._v(" "), (group.selected_business_delivery_option) ? _c('button', {
      staticClass: "dropbtn"
    }, [(group.selected_business_delivery_option.has_product_delivery_fee) ? _c('span', [_vm._v("\r\n                                    " + _vm._s(group.selected_business_delivery_option.business_delivery_option) + " -  ₦" + _vm._s(group.selected_business_delivery_option.business_product_delivery_fee) + "▼\r\n                                  ")]) : _c('span', [_vm._v("\r\n                                    " + _vm._s(group.selected_business_delivery_option.business_delivery_option) + " -  ₦" + _vm._s(group.selected_business_delivery_option.business_delivery_option_price) + "▼\r\n                                  ")])]) : _c('button', {
      staticClass: "dropbtn"
    }, [_vm._v("Select Delivery Location ▼")]), _vm._v(" "), _c('div', {
      staticClass: "dropdown-content"
    }, _vm._l((group.selected_delivery_state_locations), function(option) {
      return _c('div', [(option.business_delivery_product == 0) ? _c('span', [_c('label', [_c('span', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.sellpoint_delivery_fee),
          expression: "sellpoint_delivery_fee"
        }],
        attrs: {
          "type": "radio"
        },
        domProps: {
          "value": option.business_delivery_option_id,
          "checked": _vm._q(_vm.sellpoint_delivery_fee, option.business_delivery_option_id)
        },
        on: {
          "click": function($event) {
            _vm.calc_sellpoint_delivery_fee(index, option)
          },
          "__c": function($event) {
            _vm.sellpoint_delivery_fee = option.business_delivery_option_id
          }
        }
      })]), _vm._v(" "), _c('span', {
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v("\r\n                                          " + _vm._s(option.business_delivery_option) + " -  ₦" + _vm._s(option.business_delivery_option_price) + "\r\n                                        ")])])]) : _vm._e()])
    }))])]) : _c('div', [_c('p', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Free Delivery")])])])]) : _vm._e()])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), _vm._l((group[1]), function(item, index2) {
      return (item.can_show) ? _c('div', {
        staticClass: "row cart-details cart-item-row",
        staticStyle: {
          "margin": "0 auto",
          "margin-bottom": "8px"
        }
      }, [_c('div', {
        staticClass: "col-xs-2 cart-item-row-left",
        staticStyle: {
          "margin": "0",
          "padding": "0",
          "padding-left": "5px"
        }
      }, [_c('div', {
        staticStyle: {
          "float": "right",
          "margin-left": "0px",
          "margin-bottom": "7px"
        }
      }, [_c('div', {
        staticStyle: {
          "width": "100%",
          "padding-top": "1em"
        }
      }, [_c('a', {
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "href": item.product_url
        }
      }, [((item.product_item_image && (item.product_item_image != ''))) ? _c('img', {
        staticStyle: {
          "border-radius": "15px"
        },
        attrs: {
          "src": _vm.img_product_url + item.product_item_image,
          "width": "100%;"
        }
      }) : _c('img', {
        staticStyle: {
          "border-radius": "15px"
        },
        attrs: {
          "src": "/static/assets/images/dummy-image.png",
          "width": "100%"
        }
      })])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "padding-top": "-1.82em"
        }
      }, [(item.product_checked) ? _c('input', {
        staticClass: "check-select",
        attrs: {
          "type": "checkbox",
          "checked": ""
        },
        on: {
          "click": function($event) {
            _vm.removeFromCheckout(item, index, index2)
          }
        }
      }) : _c('input', {
        staticClass: "check-select",
        attrs: {
          "type": "checkbox"
        },
        on: {
          "click": function($event) {
            _vm.addToCheckout(item, index, index2)
          }
        }
      }), _vm._v(" "), _c('span', {
        staticStyle: {
          "font-size": "14px",
          "color": "#311010",
          "margin-left": "-0.38em"
        }
      }, [_vm._v("Select")])])])]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-10 cart-item-row-right",
        staticStyle: {
          "margin": "0",
          "padding": "0",
          "padding-top": "1em",
          "padding-left": "1em"
        }
      }, [_c('div', {
        staticClass: "w-flow",
        staticStyle: {
          "margin-top": "1px"
        }
      }, [_c('p', [_vm._v(_vm._s(item.product_name))]), _vm._v(" "), (item.product_item_order_quantity > 1) ? _c('span', {
        staticClass: "price",
        attrs: {
          "id": 'qty_t' + index2
        }
      }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(_vm.formatCurrency_2(item.product_item_order_quantity * item.product_item_price)))]) : _c('span', {
        staticClass: "price",
        attrs: {
          "id": 'qty_t' + index2
        }
      }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(_vm.formatCurrency_2(item.product_item_price)))])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "float": "right",
          "margin-top": "-3em"
        }
      }, [_c('div', {
        staticClass: "col-xs-12",
        staticStyle: {
          "margin": "0",
          "padding": "0"
        }
      }, [_c('a', {
        staticClass: "col-xs-1",
        staticStyle: {
          "cursor": "pointer",
          "text-decoration": "none",
          "padding": "1px 3px",
          "width": "25px",
          "font-weight": "bolder",
          "font-size": "14px",
          "color": "#000000"
        },
        on: {
          "click": function($event) {
            _vm.removeRefreshCheckout(item, index, index2)
          }
        }
      }, [_vm._v("–")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.product_item_order_quantity),
          expression: "item.product_item_order_quantity"
        }],
        staticClass: "col-xs-2 qty-input qty-input-sm",
        staticStyle: {
          "width": "38px"
        },
        attrs: {
          "type": "number"
        },
        domProps: {
          "value": (item.product_item_order_quantity)
        },
        on: {
          "change": function($event) {
            _vm.refreshCheckout(item, index, index2)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            item.product_item_order_quantity = $event.target.value
          }
        }
      }), _vm._v(" "), _c('a', {
        staticClass: "col-xs-1",
        staticStyle: {
          "cursor": "pointer",
          "text-decoration": "none",
          "padding": "1px 3px",
          "width": "25px",
          "font-weight": "bolder",
          "font-size": "14px",
          "color": "#ff0000"
        },
        on: {
          "click": function($event) {
            _vm.addRefreshCheckout(item, index, index2)
          }
        }
      }, [_vm._v(" +")])]), _vm._v(" "), _c('p', {
        staticStyle: {
          "color": "#f73676"
        },
        attrs: {
          "id": 'qty_c' + index2
        }
      }, [_vm._v(_vm._s(item.check_order_quantity))])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "float": "right",
          "margin-top": "3em",
          "display": "block"
        }
      }, [_c('a', {
        staticStyle: {
          "margin-right": "4px",
          "font-size": "12px",
          "color": "#ff0000",
          "cursor": "pointer"
        },
        on: {
          "click": function($event) {
            _vm.removeFromCart(item._id, index, item)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-close"
      }), _vm._v(" REMOVE")])])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "clear": "both"
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "cart-item-row-full"
      }, [_c('div', {
        staticStyle: {
          "float": "left"
        }
      }, [(group.selected_business_delivery_option && item.product_checked) ? _c('p', [(group.selected_business_delivery_option.has_product_delivery_fee) ? _c('span', _vm._l((group.selected_business_delivery_option.business_products_delivery_fees), function(pd_fee) {
        return _c('span', [(item.product_main_id == pd_fee.product_delivery_product) ? _c('span', [_vm._v("\r\n                              Shipping Fee: ₦" + _vm._s(pd_fee.product_delivery_fee) + "\r\n                              "), _vm._v(" "), _c('label', {
          staticStyle: {
            "display": "inline"
          }
        }, [_vm._v("Total: ₦" + _vm._s(item.calculated_product_delivery_fee))])]) : _vm._e()])
      })) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticStyle: {
          "float": "right",
          "display": "none"
        }
      }, [_c('span', {
        staticStyle: {
          "font-size": "12px"
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.chk),
          expression: "item.chk"
        }],
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": Array.isArray(item.chk) ? _vm._i(item.chk, null) > -1 : (item.chk)
        },
        on: {
          "click": function($event) {
            _vm.toggleSingleDisplay(item.chk, index + 's_itm_d' + index2)
          },
          "__c": function($event) {
            var $$a = item.chk,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (item.chk = $$a.concat($$v))
              } else {
                $$i > -1 && (item.chk = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              item.chk = $$c
            }
          }
        }
      }), _vm._v("Gift/Send this Product to a different location")]), _vm._v(" "), _c('div', {
        staticStyle: {
          "display": "none"
        },
        attrs: {
          "id": index + 's_itm_d' + index2
        }
      })]), _vm._v(" "), _c('div', {
        staticStyle: {
          "clear": "both"
        }
      }), _vm._v(" "), _c('div', {
        staticStyle: {
          "padding-left": "0.6em"
        }
      }, _vm._l((item.product_item_discounts), function(coupon) {
        return (coupon.discount_status_id != 8) ? _c('p', {
          staticStyle: {
            "line-height": "1.0",
            "font-size": "10px"
          }
        }, [((((coupon.discount_coupon == 'C') && (coupon.discount_product == item.product_main_id)) || ((coupon.discount_coupon == 'C') && (coupon.discount_product_item == item.product_item_id)))) ? _c('span', [(item.item_order_coupons_discounts.length == 0) ? _c('span', {
          staticStyle: {
            "color": "#4e504e",
            "font-size": "12px"
          }
        }, [_vm._v("\r\n                          Get " + _vm._s(coupon.discount_percentage) + "% Off"), ((coupon.discount_min_quantity > 0)) ? _c('span', [_vm._v(" on " + _vm._s(coupon.discount_min_quantity) + " and above order of this item")]) : _vm._e()]) : _vm._e(), _vm._v(" "), ((item.product_item_order_quantity >= coupon.discount_min_quantity)) ? _c('span', [_c('br'), _vm._v(" "), (item.product_checked) ? _c('span', [_c('input', {
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "value": coupon.discount_id + item.product_item_id
          },
          on: {
            "click": function($event) {
              _vm.set_coupons(index, index2, coupon, coupon.discount_percentage)
            }
          }
        })]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(coupon.discount_coupon_code) + " ( " + _vm._s(coupon.discount_percentage) + "% Off)\r\n                            "), _c('br'), _c('span', {
          staticStyle: {
            "color": "#ff0000",
            "font-size": "12px"
          }
        }, [(item.product_checked) ? _c('span', [_vm._v("select")]) : _vm._e(), _vm._v(" coupon")])])]) : _vm._e()]) : _vm._e()]) : _vm._e()
      })), _vm._v(" "), (_vm.buy_now_order) ? _c('div', {
        staticClass: "mobile-fix-nav"
      }, [_c('div', {
        staticStyle: {
          "background": "#ffa800",
          "width": "100vw",
          "padding": "0.8em",
          "text-align": "center"
        }
      }, [_c('a', {
        staticStyle: {
          "cursor": "pointer",
          "color": "#000000",
          "text-decoration": "none"
        },
        on: {
          "click": function($event) {
            _vm.addToCheckout(item, index, index2)
          }
        }
      }, [_vm._v("Process Order")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticStyle: {
          "clear": "both"
        }
      })]) : _vm._e()
    }), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "100%"
      }
    }, [(group.items_in_checkout > 0) ? _c('div', {
      staticStyle: {
        "width": "100%"
      }
    }, [(group.items_in_checkout > 0) ? _c('div', [((group[4] && (Object.keys(group[4]).length !== 0))) ? _c('div', {
      key: _vm.couponsComponentKey,
      staticClass: "coupons-sec"
    }, [_c('h4', {
      staticClass: "cart-hh"
    }, [_vm._v("Store Coupons")]), _vm._v(" "), _vm._l((group[4]), function(coupon, coupdex) {
      return _c('p', [(((coupon.discount_is_specific_use == 0) || ((coupon.discount_is_specific_use == 1) && (coupon.discount_module_id == _vm.user.user_id)))) ? _c('span', [(((coupon.discount_is_private == 0) || ((coupon.discount_is_private == 1) && (coupon.discount_validated == 1)))) ? _c('span', [(((coupon.discount_type == 2) || (coupon.discount_type == 3))) ? _c('span', [((group.items_in_checkout >= coupon.discount_min_quantity)) ? _c('span', [_c('input', {
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "value": coupon.discount_id
        },
        on: {
          "click": function($event) {
            _vm.set_coupons(index, 0, coupon, coupon.discount_percentage)
          }
        }
      }), _vm._v(" " + _vm._s(coupon.discount_coupon_code) + " ( " + _vm._s(coupon.discount_percentage) + "% Off )")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), ((!coupon.added && (group.items_in_checkout <= coupon.discount_min_quantity))) ? _c('span', {
        staticStyle: {
          "color": "#4e504e",
          "font-size": "12px"
        }
      }, [_vm._v("Get " + _vm._s(coupon.discount_percentage) + "% Off"), ((coupon.discount_min_quantity > 0)) ? _c('span', [_vm._v(" from " + _vm._s(coupon.discount_min_quantity) + " and above items")]) : _vm._e()]) : _vm._e()]) : _vm._e()]) : _vm._e()]) : _vm._e()])
    }), _vm._v(" "), _c('div', {}, [_c('p', {
      staticClass: "sp-app-default-color",
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v("Enter a Coupon Code if you have any")]), _vm._v(" "), _c('div', {
      staticClass: "form-group",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.coupon_entry),
        expression: "coupon_entry"
      }],
      staticClass: "form-control",
      staticStyle: {
        "float": "left",
        "width": "80%"
      },
      attrs: {
        "type": "text",
        "placeholder": "Enter Coupon"
      },
      domProps: {
        "value": (_vm.coupon_entry)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.coupon_entry = $event.target.value
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "sp-button-1 sp-button-sm btn",
      staticStyle: {
        "float": "right",
        "width": "20%",
        "padding": "0.65em",
        "background-color": "#f7efd7"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.verifyCouponEntry(index)
        }
      }
    }, [_vm._v("OK")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": "12px",
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(_vm.coupon_entry_error))])])], 2) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', [(((group.items_in_checkout > 0) || (_vm.buy_now_order))) ? _c('h4', {
      staticClass: "cart-hh"
    }, [_vm._v("Delivery Details")]) : _vm._e(), _vm._v(" "), (group.selected_delivery_state_locations && (group.selected_delivery_state_locations.length == 0)) ? _c('div', {
      staticStyle: {
        "clear": "both",
        "text-align": "left"
      }
    }, [(group.selected_business_delivery_option || group.delivery_general_set_option) ? _c('div', [(group.selected_business_delivery_option && (group.selected_business_delivery_option.business_delivery_option_price)) ? _c('p', {
      staticStyle: {
        "font-size": "13px"
      }
    }, [_c('b', [_vm._v("Shipping: ")]), _vm._v(_vm._s(group.selected_business_delivery_option.business_delivery_option) + " - ₦" + _vm._s(group.selected_business_delivery_option.business_delivery_option_price))]) : _vm._e(), _vm._v(" "), (group.delivery_general_set_option && (group.delivery_general_set_option.city)) ? _c('p', {
      staticStyle: {
        "font-size": "13px"
      }
    }, [_c('b', [_vm._v("Shipping: ")]), _vm._v(_vm._s(group.delivery_general_set_option.city.city_name) + "-" + _vm._s(group.delivery_option))]) : _vm._e()]) : _c('div', [(group.business_min_delivery_fee != 0 && (group.business_max_delivery_fee.length != 0)) ? _c('div', [_c('p', {
      staticStyle: {
        "font-size": "13px"
      }
    }, [_c('b', [_vm._v("Shipping: ")]), _vm._v("₦" + _vm._s(group.business_min_delivery_fee) + " - ₦" + _vm._s(group.business_max_delivery_fee))])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (((group.items_in_checkout > 0) || (_vm.buy_now_order))) ? _c('div', [_vm._m(0, true), _vm._v(" "), _c('div', {
      key: _vm.shipping_fee_key_options,
      staticStyle: {
        "width": "80%",
        "float": "right",
        "padding": "3px"
      }
    }, [_c('p', [_c('span', [_c('b', [(group.delivery_selected_state && (Object.keys(group.delivery_selected_state).length > 0)) ? _c('span', [_vm._v("\r\n                              " + _vm._s(group.delivery_selected_state.state_name) + "\r\n                            ")]) : _c('span', [_vm._v("No Address set")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [(group.selected_business_delivery_option && (Object.keys(group.selected_business_delivery_option).length > 0)) ? _c('span', [_vm._v("\r\n                              " + _vm._s(group.selected_business_delivery_option.business_delivery_option) + "\r\n                            ")]) : _c('span', [_vm._v("Select Delivery location")])])])]), _vm._v(" "), (_vm.buy_now_order) ? _c('div', {
      staticStyle: {
        "width": "5%",
        "float": "right",
        "margin-left": "9em",
        "margin-top": "-4em",
        "padding": "1em",
        "text-align": "center"
      }
    }, [_c('i', {
      staticClass: "fa fa-angle-right",
      staticStyle: {
        "font-weight": "bolder",
        "font-size": "18px"
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]) : _vm._e(), _vm._v(" "), (group.items_in_checkout > 0) ? _c('div', {
      staticClass: "delivery-sec",
      staticStyle: {
        "width": "100%"
      }
    }, [(group.show_delivery_option > 0) ? _c('div', [_c('div', {
      key: _vm.shipping_fee_key_options
    }, [(group[2]) ? _c('div', [_c('div', [(group[2].length != 0 && !group.delivery_option) ? _c('span', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Please select a delivery option"), _c('br')]) : _vm._e()]), _vm._v(" "), (group.delivery_states.length == 1) ? _c('div', [_vm._v("\r\n                              Shipping State:" + _vm._s(group.delivery_states[0].state_name) + "\r\n                            ")]) : _c('div', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.delivery_selected_state),
        expression: "group.delivery_selected_state"
      }],
      staticClass: "sp-form-select sp-select",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          group.delivery_selected_state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.getDeliveryLocations(index, group.delivery_selected_state)
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select")]), _vm._v(" "), _vm._l((group.delivery_states), function(state) {
      return _c('option', {
        domProps: {
          "value": state
        }
      }, [_vm._v(_vm._s(state.state_name))])
    })], 2)])]) : _c('div', [_c('div', {}, [_c('label', [_vm._v("State: ")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.order_delivery_main_location.state),
        expression: "order_delivery_main_location.state"
      }],
      staticClass: "sp-form-select sp-select",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.order_delivery_main_location.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.getCities(_vm.order_delivery_main_location.state)
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select...")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
      return _c('option', {
        domProps: {
          "value": state
        }
      }, [_vm._v(_vm._s(state.name))])
    })], 2)]), _vm._v(" "), (_vm.cities.length != 0) ? _c('div', {}, [_c('label', [_vm._v("Location: ")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.order_delivery_main_location.city),
        expression: "order_delivery_main_location.city"
      }],
      staticClass: "sp-form-select sp-select",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.order_delivery_main_location.city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.setOrderLocations(_vm.order_delivery_main_location)
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select...")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
      return _c('option', {
        domProps: {
          "value": city
        }
      }, [_vm._v(_vm._s(city.city_name))])
    })], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
      attrs: {
        "id": index + 'BDLS'
      }
    }, [_c('div', {
      key: _vm.componentDeliveryLocationsKey
    }, [(group.selected_delivery_state_locations.length != 0) ? _c('div', [_c('div', {
      staticClass: "dropdown"
    }, [(group.selected_business_delivery_option) ? _c('button', {
      staticClass: "dropbtn"
    }, [(group.selected_business_delivery_option.has_product_delivery_fee) ? _c('span', [_vm._v("\r\n                                      " + _vm._s(group.selected_business_delivery_option.business_delivery_option) + " -  ₦" + _vm._s(group.selected_business_delivery_option.business_product_delivery_fee) + "▼\r\n                                    ")]) : _c('span', [_vm._v("\r\n                                      " + _vm._s(group.selected_business_delivery_option.business_delivery_option) + " -  ₦" + _vm._s(group.selected_business_delivery_option.business_delivery_option_price) + "▼\r\n                                    ")])]) : _c('button', {
      staticClass: "dropbtn",
      on: {
        "click": function($event) {
          _vm.showDropdown('deliveryLocation1')
        }
      }
    }, [_vm._v("Select Delivery Location ▼")]), _vm._v(" "), _c('div', {
      staticClass: "dropdown-content",
      attrs: {
        "id": "deliveryLocation1"
      }
    }, _vm._l((group.selected_delivery_state_locations), function(option) {
      return _c('div', [(option.business_delivery_product == 0) ? _c('span', [_c('label', [((group.items_in_checkout > 0)) ? _c('span', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.sellpoint_delivery_fee),
          expression: "sellpoint_delivery_fee"
        }],
        attrs: {
          "type": "radio"
        },
        domProps: {
          "value": option.business_delivery_option_id,
          "checked": _vm._q(_vm.sellpoint_delivery_fee, option.business_delivery_option_id)
        },
        on: {
          "click": function($event) {
            _vm.calc_sellpoint_delivery_fee(index, option)
          },
          "__c": function($event) {
            _vm.sellpoint_delivery_fee = option.business_delivery_option_id
          }
        }
      })]) : _vm._e(), _vm._v(" "), _c('span', {
        staticStyle: {
          "font-size": "12px"
        }
      }, [(option.business_is_delivery_business == 1) ? _c('span', {
        staticStyle: {
          "color": "#96c5f5"
        }
      }, [_vm._v(_vm._s(option.business_delivery_business_name)), _c('br')]) : _vm._e(), _vm._v(_vm._s(option.business_delivery_option) + " -  ₦" + _vm._s(option.business_delivery_option_price) + "\r\n                                          ")])])]) : _vm._e()])
    }))])]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "1em"
      }
    }, [_c('p', {
      staticClass: "tiny-part",
      staticStyle: {
        "line-height": "0.4"
      }
    }, [_vm._v("Total Orders ₦" + _vm._s(parseFloat(group.total_order_amt).toFixed(2)))]), _vm._v(" "), (group[2]) ? _c('span', [_c('p', {
      key: _vm.shipping_fee_key,
      staticClass: "tiny-part",
      staticStyle: {
        "line-height": "0.4"
      }
    }, [_vm._v("Shipping Fee:  ₦" + _vm._s(group.total_delivery_charge))]), _vm._v(" "), _c('p', {
      key: _vm.total_orders_key,
      staticClass: "tiny-part",
      staticStyle: {
        "line-height": "0.4"
      }
    }, [_vm._v("Total: ₦" + _vm._s(parseFloat(group.total_order_amt + group.total_delivery_charge).toFixed(2)))])]) : _c('span', [_c('p', {
      staticClass: "tiny-part"
    }, [_c('b', [_vm._v("Shipping Details:")]), _vm._v(" " + _vm._s(group.delivery_option))])]), _vm._v(" "), (group[3]) ? _c('div', {
      staticClass: "row",
      staticStyle: {
        "display": "none"
      }
    }, [_vm._m(1, true), _vm._v(" "), (!group.payment_mode) ? _c('span', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Please select a payment option"), _c('br')]) : _vm._e(), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.payment_option),
        expression: "payment_option"
      }],
      attrs: {
        "type": "radio",
        "value": "pay_on_delivrey"
      },
      domProps: {
        "checked": _vm._q(_vm.payment_option, "pay_on_delivrey")
      },
      on: {
        "click": function($event) {
          _vm.setPaymentOption(index, 2)
        },
        "__c": function($event) {
          _vm.payment_option = "pay_on_delivrey"
        }
      }
    }), _c('label', [_vm._v("Pay On Delivery")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.payment_option),
        expression: "payment_option"
      }],
      attrs: {
        "type": "radio",
        "value": "pay_now"
      },
      domProps: {
        "checked": _vm._q(_vm.payment_option, "pay_now")
      },
      on: {
        "click": function($event) {
          _vm.setPaymentOption(index, 1)
        },
        "__c": function($event) {
          _vm.payment_option = "pay_now"
        }
      }
    }), _c('label', [_vm._v("Pay Now")])]) : _vm._e()])]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])], 2) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "mobile-fix-nav"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000",
      "margin-left": "15px"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.total_order_amt == 0 && (_vm.data_processing_message == '')) ? _c('span', {
    staticStyle: {
      "clear": "both",
      "color": "#ff0000",
      "margin-left": "15px"
    }
  }, [_vm._v("Select items to checkout")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card card-out-colord-pad",
    staticStyle: {
      "text-align": "left",
      "margin-top": "1em"
    }
  }, [(!_vm.buy_now_order) ? _c('div', {}, [_c('div', {
    staticClass: "size-h3 margin-bottom"
  }, [_vm._m(2), _vm._v(" "), _c('span', {
    staticClass: "fl-right"
  }, [_vm._v("(" + _vm._s(_vm.cart.length) + " items)")]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', {
    staticClass: "c-cart__section in-cart-page"
  }, [_c('p', [_c('span', {
    staticClass: "fl-left"
  }, [_vm._v("Subtotal ")]), _vm._v(" "), _c('span', {
    staticClass: "fl-right"
  }, [_vm._v("₦" + _vm._s(_vm.formatCurrency_2(_vm.total_order_amt)))]), _vm._v(" "), _c('span', {
    staticClass: "clear"
  })]), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "fl-left"
  }, [_vm._v("Shipping ")]), _vm._v(" "), _c('span', {
    staticClass: "fl-right"
  }, [_vm._v("₦" + _vm._s(_vm.formatCurrency_2(_vm.total_delivery_fee)))]), _vm._v(" "), _c('span', {
    staticClass: "clear"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]) : _vm._e(), _vm._v(" "), _c('div', {}, [_c('div', {}, [(_vm.buy_now_order) ? _c('span', [_c('b', [_vm._v("Order Total")]), _c('br'), _vm._v(" ₦" + _vm._s(_vm.formatCurrency_2(_vm.total_order_amt + _vm.total_delivery_fee)))]) : _c('span', [_c('h4', {
    staticClass: "cart-hh"
  }, [_vm._m(3), _vm._v(" "), _c('span', {
    staticClass: "fl-right"
  }, [_vm._v("₦" + _vm._s(_vm.formatCurrency_2(_vm.total_order_amt + _vm.total_delivery_fee)))])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "#ffa800",
      "width": "100vw",
      "padding": "0.8em",
      "text-align": "center"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#000000",
      "background": "#ffa800",
      "text-decoration": "none"
    },
    attrs: {
      "disabled": _vm.disable_btn_01
    },
    on: {
      "click": function($event) {
        _vm.process_orders()
      }
    }
  }, [_vm._v("Process Orders")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-colord-pad card-colord-01",
    staticStyle: {
      "width": "15%",
      "float": "left",
      "padding": "1em",
      "border-radius": "5px",
      "text-align": "center"
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker",
    staticStyle: {
      "font-weight": "bolder",
      "font-size": "18px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tiny-part"
  }, [_c('b', [_vm._v("Payment Mode")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "fl-left"
  }, [_c('h5', [_c('b', [_vm._v("Cart totals")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "fl-left"
  }, [_c('b', [_vm._v("Total ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ba01caf"}!./src/pages/Orderpoint/CartWidget/template.html
// module id = 512
// module chunks = 0